import {APIService} from "./api.service";
import {Injectable} from "@angular/core";
import {IIssueRefund} from "../interfaces/IIssueRefund";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor(private apiService: APIService) {

  }

  public issueRefund(issueRefundRequest: IIssueRefund) {
    return this.apiService.MakePostRequest(`payments/issue-refund`, issueRefundRequest);
  }

}
